import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BucketOptions, ChartOptions } from "@library";
import { InfosheetMeasurementSummaryOverrides, MeasurementSummaryOverrides } from '@core/data';

export interface MeasureSummaryOptionsFormDialogData {
    chartOptions: ChartOptions[];
    bucketOptions: BucketOptions[];
    override: MeasurementSummaryOverrides | InfosheetMeasurementSummaryOverrides;
    formGroupName?: string;
}

@Component({
    selector: 'pv-measure-summary-options-form-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    templateUrl: 'measure-summary-options-form.dialog.html'
})
export class MeasureSummaryOptionsFormDialog {

    formGroup = new FormGroup({
        bucketId: new FormControl(null),
        chartId: new FormControl(null),
        displayChart: new FormControl(true),
        displayStats: new FormControl(true),
        displayAverage: new FormControl(true),
    });

    chartOptions: ChartOptions[];
    bucketOptions: BucketOptions[];
    formGroupName: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: MeasureSummaryOptionsFormDialogData,
        private _dialogRef: MatDialogRef<MeasureSummaryOptionsFormDialog>
    ) {
        // legacy overrides have no display* values; absent means visible
        this.formGroup.reset({
            ..._data.override,
            displayChart: _data.override?.displayChart ?? true,
            displayStats: _data.override?.displayStats ?? true,
            displayAverage: _data.override?.displayAverage ?? true,
        });
        this.chartOptions = _data.chartOptions;
        this.bucketOptions = _data.bucketOptions;
        this.formGroupName = _data.formGroupName;
    }

    submit(){
        const form = this.formGroup.value;

        const data: MeasurementSummaryOverrides | InfosheetMeasurementSummaryOverrides = {
            ...this._data.override,
            ...this.formGroup.value,
            displayChart: form.displayChart ?? true,
            displayStats: form.displayStats ?? true,
            displayAverage: form.displayAverage ?? true,
        }

        this._dialogRef.close(data);
    }


}

